<template>
  <div>

  <header>
            <Header
        :HideCart='true'
        Title='novo endereço'
        class="mb-5" 
        />
  </header>

  <section style="max-height:99vh">


    <form class='register'>

      <TitleH1
      class='titleh1 container'
      Text='Cadastre seu endereço'
      />


      <InputRedLight
          class="inputName" 
          autoComplete="off"
          placeholder='CEP'
          id="CEP"
          type="text"
          minLength=6
          maxLength=50
          title="Digite seu CEP"
          v-model='endereco.cep' 

       />

      <InputRedLight
          autoComplete="off"
          placeholder='Endereço'
          id="text"
          type="text"
          minLength=6
          maxLength=50
          title="Digite seu endereço"
          v-model='endereco.rua' 

       />

      <InputRedLight
          autoComplete="off"
          placeholder='Número'
          id="text"
          type="text"
          minLength=6
          maxLength=50
          title="Digite seu número"
          v-model='endereco.numero' 

       />

       <InputRedLight
          autoComplete="off"
          placeholder='Complemento'
          id="text"
          type="text"
          minLength=6
          maxLength=50
          title="Digite seu complemento"
          v-model='endereco.complemento' 

       />



        <Button
        id='next_button'
        Type='submit'
        Text='CADASTRAR ENDEREÇO'
        :ButtonFunction='next_step'
        />

    </form>

  </section>
  </div> 
</template>

<script>
import InputRedLight from '../../components/Input/InputRedLight'
import Header from '../../components/Header/Header'
import Logo from '../../assets/img/appName.svg'
import TitleH1 from '../../components/Title/TitleH3'
import Button from '../../components/Button/ButtonCallToAction'
// API DE CEP https://github.com/BrasilAPI/BrasilAPI


export default {
  components: {
    InputRedLight,
    Header,
    TitleH1,
    Button,
  },
  data() {
    return {
      Logo: Logo,
      endereco: {
        cep: '',
        rua: '',
        numero: '',
        cidade: '',
        estado: '',
      }
    }
  },
  methods: {
    next_step() {
      console.log('next step', this.endereco.cep, this.endereco.rua,this.endereco.numero,this.endereco.cidade,this.endereco.estado)
    }
  },
}
</script>

<style scoped lang="css">

.titleh1{
  display: flex;
align-items: center;
text-align: center;
}

.inputName{
  margin-top:5.25rem;
}

#next_button{
  margin-top:7.5rem;
}
  .register{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:6.25rem;  
}

  @media (min-width: 1400px) and (max-width: 2600px) {
  .register{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }
</style>
